import React from 'react';
import gruveLogo from '../../assets/gruve-logo.png';
import { isSankalvaX } from '../../config/branding';

const GruveLogo = ({ size = 'w-12 h-12', className = '' }) => {
  // Only show SankalvaX logo when on platform.sankalvax.ai
  if (isSankalvaX()) {
    return (
      <img
        src="/sankalvax-logo-brand.svg"
        alt="SankalvaX"
        className={`${size} ${className} object-contain`}
      />
    );
  }

  // Default: Gruve logo (current behavior)
  return (
    <img
      src={gruveLogo}
      alt="Gruve"
      className={`${size} ${className} object-contain`}
    />
  );
};

export default GruveLogo;
